import { render } from "./SubscriberBadge.vue?vue&type=template&id=531a6695&scoped=true"
import script from "./SubscriberBadge.vue?vue&type=script&lang=js"
export * from "./SubscriberBadge.vue?vue&type=script&lang=js"

import "./SubscriberBadge.vue?vue&type=style&index=0&id=531a6695&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-531a6695"]])

export default __exports__